import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import february from './february';
import march from './march';
import april from './april';
import may from './may';
import june from './june';

import Calendario from './Calendario/Calendario';

class Cronograma extends Component {
  state = {
    february,
    march,
    april,
    may,
    june
  }

  render() {
    return (
      <React.Fragment>
        <Grid container justify="center" style={{ paddingBottom: '1rem', paddingTop: '1rem' }}>
          <Grid item xs={10}>
            <Typography variant="h3" style={{ textAlign: 'center', color: '#5dc8ae', paddingBottom: '1rem', paddingTop: '1rem' }}>
              Cronograma
            </Typography>
            <Grid container spacing={32}>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" style={{ textAlign: 'center' }}>
                  Fevereiro
                </Typography>
                <Calendario days={this.state.february}></Calendario>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" style={{ textAlign: 'center' }}>
                  Março
                </Typography>
                <Calendario days={this.state.march}></Calendario>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" style={{ textAlign: 'center' }}>
                  Abril
                </Typography>
                <Calendario days={this.state.april}></Calendario>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" style={{ textAlign: 'center' }}>
                  Maio
                </Typography>
                <Calendario days={this.state.may}></Calendario>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" style={{ textAlign: 'center' }}>
                  Junho
                </Typography>
                <Calendario days={this.state.june}></Calendario>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment >
    );
  }
}

export default Cronograma